import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IonButton } from '@ionic/react';
import { returnToSignin } from '../../utils/nav';
import './RegisterVerify.css';
import { apiResendVerification } from '../../services/api';
import {
  getAppError,
  getAppSuccess,
  getUserMessageOrValidationError,
} from '../../utils/messages';
import { useHistory } from 'react-router';
import { useToaster } from '../../hooks/useToaster';

type RegisterVerifyProps = {
  email: string;
  time: Date;
  setTime: (t: Date) => void;
};

export default function RegisterVerify({
  email,
  time,
  setTime,
}: RegisterVerifyProps) {
  const [t] = useTranslation('global');
  const router = useHistory();
  const [present] = useToaster();

  const [now, setNow] = useState<Date>(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(new Date());
    }, 300);
    return () => clearInterval(interval);
  }, []);

  const okin = 30 - Math.round((now.getTime() - time.getTime()) / 1000);
  const disabled = okin > 0;

  const resendEmail = async () => {
    try {
      await apiResendVerification(email);
      present(getAppSuccess(t('register.resendsuccess')));
      setTime(new Date());
    } catch (error) {
      console.error('Error sending email ', error);
      const apiError = getUserMessageOrValidationError(error);
      if (typeof apiError === 'string') {
        present(getAppError(apiError));
      } else {
        present(getAppError(t('register.resendnosuccess')));
      }
    }
  };

  return (
    <>
      <h1 className="h1 ion-text-center h1plus">{t('register.verifytitle')}</h1>
      <p className="pt-2 pb-4 instructions ion-text-center">
        <span>{t('register.verifyinfo1')}</span>
        <br />
        <br />
        <span>{t('register.verifyinfo2')}</span>
      </p>

      <div className="pt-4 ion-text-center">
        <IonButton
          className="btn-default btn-wide-80"
          onClick={() => returnToSignin(router)}
        >
          {t('home.signin')}
        </IonButton>
      </div>

      <div className="pt-1 ion-text-center">
        <IonButton
          className={
            'btn-default btn-inverted btn-wide-80 ' +
            (disabled ? 'btn-disabled' : '')
          }
          disabled={disabled}
          onClick={() => resendEmail()}
        >
          {t('register.resend')}
        </IonButton>
      </div>

      {okin == 1 && (
        <div className="ion-text-center register-verify-future">
          {t('register.resendin1')}
        </div>
      )}
      {okin < 1 && (
        <div className="ion-text-center register-verify-now">
          {t('register.resendin0')}
        </div>
      )}
      {okin > 1 && (
        <div className="ion-text-center register-verify-future">
          {t('register.resendinn', { t: okin })}
        </div>
      )}
    </>
  );
}
